/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import { connect } from "react-redux";
import gql from "graphql-tag";
import { spinnerService } from "@chevtek/react-spinners";
import { toast } from "react-toastify";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import StarIcon from "@material-ui/icons/Star";
import * as actionTypes from "../../redux/actions";
import { ListItemSecondaryAction } from "@material-ui/core";
import PropTypes from "prop-types";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { Row, Col } from "reactstrap";
import imgPlaceholder from "../../assets/img/logo-placeholder.jpg";
import { Storage } from "aws-amplify";
import { getVendorTeamExt } from "../../data/customQueries.js";
import { Cache } from "aws-amplify";
const MechanicDashboard = ({ client, user, ...props }) => {
  const [customersList, setCustomersList] = useState([]);
  const [logo, setLogo] = useState(imgPlaceholder);
  const [dispInfo, setDispInfo] = useState({});
  const fetchData = async () => {
    let cacheName = JSON.stringify("custList@" + user.username);
    spinnerService.show("mySpinner");
    // Cache.removeItem(cacheName);
    const cachedData = await JSON.parse(Cache.getItem(cacheName));
    
    if (![null, undefined].includes(cachedData)) {
      setCustomersList(cachedData.data);
      setDispInfo(cachedData.info);
      spinnerService.hide("mySpinner");
      const mechanic = await client.query({
        query: gql(getVendorTeamExt),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      });
      const vendor = mechanic.data.getVendorTeam.vendor;
      let pic = vendor.picture;
      if (pic !== null) {
        if (pic !== undefined) {
          Storage.get(pic.key)
            .then(pictureObj => {
              setLogo(pictureObj);
            })
            .catch(() => {});
        }
      }
      return;
    } else {
      const mechanic = await client.query({
        query: gql(getVendorTeamExt),
        fetchPolicy: `network-only`,
        variables: { id: user.username }
      });
      const mech = mechanic.data.getVendorTeam;
      const vendor = mechanic.data.getVendorTeam.vendor;
      let pic = vendor.picture;
      if (pic !== null) {
        if (pic !== undefined) {
          Storage.get(pic.key)
            .then(pictureObj => {
              setLogo(pictureObj);
            })
            .catch(() => {});
        }
      }
      let dispObj = {
        Name: mech.firstName + " " + mech.lastName,
        company: vendor.companyName
      };
      setDispInfo(dispObj);
      const cust = vendor.customers;
      let temp = [];
      let url = "";
      if (cust && cust.items.length > 0) {
        await cust.items.map(c => {
          let pic = c.customer.picture;
          if (pic !== null) {
            if (pic !== undefined) {
              Storage.get(pic.key)
                .then(pictureObj => {
                  if ([null, undefined].includes(pictureObj)) {
                    url = imgPlaceholder;
                  } else url = pictureObj;
                })
                .catch(() => {});
            }
          }
          temp.push({
            id: c.customer.id,
            company: c.customer.companyName,
            logo: url ? url : imgPlaceholder,
            isSelected: false,
            vendor: vendor.id
          });
        });
        await Cache.setItem(
          cacheName,
          JSON.stringify({ data: temp, info: dispObj })
        );
        await setCustomersList(temp);
        spinnerService.hide("mySpinner");
      } else spinnerService.hide("mySpinner");
    }
  };

  const handleChangeCustomer = val => {
    try {
      if (![null, undefined, ""].includes(props.custformech))
        props.customerForMechanic(val);
      props.history.push(`/mech/customer/${val}`, {
        active: val
      });
    } catch (err) {
      fetchData();
      toast.err("Something Went Wrong");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <React.Fragment>
      <Row>
        <Col xs={12} sm={6} lg={6}>
          <div style={{ float: "left" }}>
            <Avatar style={{ height: 80, width: 80 }}>
              <img src={logo} style={{ height: 80, width: 80 }} alt="..." />
            </Avatar>
          </div>
          <div style={{ float: "left", paddingLeft: 10, marginTop: 10 }}>
            <div style={{ fontSize: "24px" }}>{dispInfo.company}</div>
            <div style={{ marginTop: "10px" }}>Welcome {dispInfo.Name}</div>
          </div>
        </Col>
        <Col xs={12} sm={6} lg={6}>
          <div style={{ float: "right" }}></div>
        </Col>
      </Row>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ float: "left", padding: "10px" }}></div>
          <Card>
            <CardHeader>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center"
                }}
              >
                <h5>Select Company To View Vehicles</h5>
              </div>
            </CardHeader>
            <CardBody style={{ minHeight: 585, paddingLeft: "25%" }}>
              <List
                dense
                style={{
                  width: "50%"
                }}
              >
                <ListItem disabled>
                  <ListItemAvatar>
                    <Avatar alt={``} src={``} />
                  </ListItemAvatar>
                  <ListItemText primary="Company" />
                  <ListItemSecondaryAction>Active</ListItemSecondaryAction>
                </ListItem>
              </List>
              <List
                dense
                // component="nav"
                style={{
                  width: "50%"
                }}
              >
                {customersList.map(li => (
                  <ListItem
                    button
                    key={li.id}
                    onClick={() => handleChangeCustomer(li.id)}
                  >
                    <ListItemAvatar>
                      <Avatar alt={`Customer`} src={`${li.logo}`} />
                    </ListItemAvatar>
                    <ListItemText primary={li.company} />
                    {props.custformech === li.id && (
                      <ListItemSecondaryAction>
                        {" "}
                        <StarIcon />{" "}
                      </ListItemSecondaryAction>
                    )}
                  </ListItem>
                ))}
              </List>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </React.Fragment>
  );
};
MechanicDashboard.propTypes = {
  custformech: PropTypes.string,
  location: PropTypes.object,
  history: PropTypes.object,
  customerForMechanic: PropTypes.func,
  client: PropTypes.object,
  user: PropTypes.object
};
const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client,
    custformech: state.config.custformech
  };
};
const mapDispatchToProps = dispatch => {
  return {
    customerForMechanic: data => dispatch(actionTypes.customerForMechanic(data))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MechanicDashboard);



// WEBPACK FOOTER //
// ./src/views/Dashboard/MechanicDashboard.jsx